import { useEffect, useState } from 'react';
import nodeTypesAPI from '../api/nodeTypes';

// The node catalogue from GET /v2/node-types (DWLF-370): the signal builders'
// `nodeTypes` prop and the FSM builder's event list. Fetched when a page mounts
// (no module cache: nothing may outlive RESET_STATE, charter invariant 3).
// `loading` until it settles; then `catalogue`, or `failed` — the builders say
// the catalogue is unavailable rather than offering a list of their own.
export default function useNodeTypes() {
  const [state, setState] = useState({ catalogue: null, loading: true, failed: false });
  useEffect(() => {
    let live = true;
    nodeTypesAPI.catalogue()
      .then((catalogue) => { if (live) {setState({ catalogue, loading: false, failed: false });} })
      .catch((error) => {
        console.error('useNodeTypes: could not load /node-types', error);
        if (live) {setState({ catalogue: null, loading: false, failed: true });}
      });
    return () => { live = false; };
  }, []);
  return state;
}
